import { ListChecks, type LucideIcon } from 'lucide-react';

export const MultiSelectIcon: LucideIcon = ListChecks;
